<template>
    <div class="bg-white">
        <Head>
            <title>Правила перебування на озерах Хвиля</title>
        </Head>
        <Header :cart-count="cartCount"/>
        <div class="mx-auto max-w-2xl px-4 py-4 sm:px-6 sm:py-8 lg:max-w-7xl lg:px-8">
            <h2 class="page-title">Публічна оферта</h2>
            <h3 class="text-2xl mt-8">Загальні положення</h3>
            <p class="my-2 leading-7">1.1. Ця публічна оферта (далі – “Оферта”) є пропозицією ПП “Хвиля-2007” (далі – “Виконавець”) з надання послуг зі спортивної та любительскої риболовлі (далі – “Послуги”) на умовах, викладених у цьому документі, і адресована будь-якій фізичній чи юридичній особі (далі – “Замовник”).</p>
            <p class="my-2 leading-7">1.2. Укладання договору про надання Послуг (далі – “Договір”) здійснюється шляхом акцепту Замовником умов Оферти.</p>
            <p class="my-2 leading-7">1.3. Акцепт Оферти здійснюється шляхом оплати Замовником Послуг, що надаються Виконавцем відповідно до умов цієї Оферти.</p>

            <h3 class="text-2xl mt-8">Предмет Оферти</h3>
            <p class="my-2 leading-7">2.1. Виконавець зобов’язується надати Замовнику Послуги, а Замовник зобов’язується сплатити вартість Послуг відповідно до умов цієї Оферти.</p>

            <h3 class="text-2xl mt-8">Умови надання Послуг</h3>
            <p class="my-2 leading-7">3.1. Виконавець надає Послуги зі спортивної та любительскої риболовлі на різних водоймах.</p>

            <p class="my-2 leading-7">3.2. Послуги можуть включати:</p>
            <ul class="leading-7 list-disc ml-12">
                <li>організацію риболовних екскурсій і турів;</li>
                <li>надання риболовного обладнання та снастей;</li>
                <li>навчання технікам риболовлі;</li>
                <li>організацію змагань з риболовлі;</li>
                <li>організацію риболовних семінарів та майстер-класів.</li>
            </ul>
            <p class="my-2 leading-7">3.3. Виконавець має право змінювати перелік Послуг, їх вартість та інші умови надання Послуг шляхом розміщення інформаціії на сайті https://wave.fishing/.</p>
            <p class="my-2 leading-7">3.4. Деталі надання Послуг, їх вартість, терміни та інші умови визначаються в кожному конкретному випадку на основі заявки Замовника та узгодження з Виконавцем.</p>

            <h3 class="text-2xl mt-8">Оплата Послуг</h3>
            <p class="my-2 leading-7">4.1. Вартість Послуг визначається Виконавцем на основі вартості окремих видів Послуг, які обрані Замовником, та розміщена на сайті https://wave.fishing/.</p>
            <p class="my-2 leading-7">4.2. Замовник оплачує Послуги у безготівковій формі шляхом перерахування коштів на розрахунковий рахунок Виконавця.</p>
            <p class="my-2 leading-7">4.3. Замовник має право відмовитись від оплачених Послуг та отримати повернення коштів за умови повідомлення Виконавця про таку відмову не пізніше ніж за 7 днів до дати надання Послуг.</p>

            <h3 class="text-2xl mt-8">Відповідальність сторін</h3>
            <p class="my-2 leading-7">5.1. Виконавець не несе відповідальності за можливі неприємності, пов’язані з погодними умовами, відмовою дозволів на риболовлю або іншими обставинами, які виникли не з вини Виконавця.</p>
            <p class="my-2 leading-7">5.2. Замовник несе відповідальність за дотримання правил риболовлі, встановлених законодавством, а також за збереження та своєчасне повернення наданого Виконавцем обладнання та снастей.</p>
            <p class="my-2 leading-7">5.3. У разі пошкодження або втрати обладнання чи снастей, наданих Виконавцем, Замовник зобов’язаний відшкодувати вартість такого обладнання або снастей.</p>

            <h3 class="text-2xl mt-8">Інші умови</h3>
            <p class="my-2 leading-7">6.1. Усі спори, що виникають між сторонами у зв’язку з виконанням умов цієї Оферти, вирішуються шляхом переговорів. У разі недосягнення домовлен ості, спори передаються на розгляд компетентного суду відповідно до чинного законодавства.</p>
            <p class="my-2 leading-7">6.2. Виконавець має право змінювати умови цієї Оферти в будь-який час, розміщуючи зміни на сайті https://wave.fishing/. Зміни набирають чинності з моменту їх розміщення на сайті, якщо інше не вказано в самому тексті змін.</p>
            <p class="my-2 leading-7">6.3. Виконавець зобов’язується забезпечити конфіденційність персональних даних Замовника та використовувати їх виключно в межах надання Послуг.</p>
            <p class="my-2 leading-7">6.4. Усі питання, що не врегульовані цією Офертою, вирішуються відповідно до чинного законодавства.</p>

            <p class="mt-10 leading-7"><b>Реквізити Виконавця ПП “Хвиля-2007”</b></p>
            <p class="my-2 leading-7"><b>Адреса:</b> м. Суми, вул. Косівщинська, офіс 25</p>
            <p class="my-2 leading-7"><b>Телефон:</b> +38 (050) 864-14-28</p>
            <p class="my-2 leading-7"><b>Розрахунковий рахунок:</b> UA973375460000026001005200967</p>
            <p class="my-2 leading-7"><b>Банк:</b> АТ КБ «ПриватБанк»</p>
            <p class="my-2 leading-7"><b>ЄДРПОУ:</b> 35067870</p>
        </div>
    </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Header from "@/Component/Header.vue";
export default {
    components: {
        Header,
        Head,
    },
    props: {
        cartCount: {
            type: Number,
            default: 0
        }
    }
}
</script>
